import { useTranslation } from "react-i18next"
import { FormAutocomplete } from "../common/FormAutocomplete"
import { CHALLENGE_TIMING } from "./Organize.utilities"

/**
 * Filter dropdown for the Challenges list, matching Challenge Timing values
 * (`0` before, `1` during, `2` after). `null` shows every challenge.
 */
const TimingFilter = ({ onSelect, timing }) => {
    const { t } = useTranslation()

    return (
        <div data-testid="challenge__timing-filter">
            <FormAutocomplete
                disableClearable
                label={t('Challenge Timing')}
                defaultText={t('All timings')}
                onChange={(e, option) => onSelect(option?.id ?? null)}
                options={[
                    { id: CHALLENGE_TIMING.BEFORE, name: t('Before the game') },
                    { id: CHALLENGE_TIMING.DURING, name: t('During the game') },
                    { id: CHALLENGE_TIMING.AFTER, name: t('After the game') },
                ]}
                size="small"
                stateful={false}
                value={timing}
            />
        </div>
    )
}

export default TimingFilter
